module.exports = __webpack_public_path__ + "media/images/mailer/forum-48-primary-57dfbfdac1341914d5e7a238cfad523f.png";